import { useState } from "react";
import { styles } from "./img-list-section";
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { colors } from "../../utils/const";
import { useI18n } from "@/i18n/I18nProvider";
import Number from "./Number.jsx";
import { getProductsText } from "../../../locales/products";
export default function ImgListSection({ title, img }) {
  const { t, locale } = useI18n();
  const products = getProductsText(locale);
  const [state, setState] = useState("");
  return (
    <Container
      maxWidth="xl"
      sx={styles.sectionContainer}
      className=" vertical-safe-padding"
    >
      <Box
        component="img"
        src="https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/img-list.webp"
        alt="image list"
        loading="lazy"
        sx={{
          width: { xs: "200px", sm: "350px", md: "500px" },
          height: { xs: "170px", sm: "300px", md: "430px" },
          textAlign: "center",
        }}
      />
      <Box>
        <Box
          sx={{
            position: "relative",
            display: "inline-block",
            zIndex: 1,
            mb: "15px",
          }}
        >
          {/* Overlay */}
          <Box
            sx={{
              content: '""',
              position: "absolute",
              inset: 0,
              backgroundColor: "rgba(0, 0, 0, 0.0)",
              zIndex: -1,
            }}
          />
          <Box
            sx={{
              fontSize: "42px",
              color: colors.orange,
              fontWeight: "600",
            }}
          >
            {products.shopiing_page.section_b.title}
          </Box>
        </Box>

        <Box sx={{ mt: 2, mb: 4 }}>
          {products.shopiing_page.section_b.description}
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            fontSize: "30px",
            gap: 4,
          }}
        >
          <Box
            sx={{ display: "flex", gap: 2 }}
            onMouseEnter={() => setState("1")}
            onMouseLeave={() => setState("")}
          >
            <Number n="1" state={state} />
            <Box
              component="span"
              sx={{
                width: { xs: "300px", sm: "500px", md: "650px" },
                fontSize: { xs: "15px", sm: "20px" },
                color: "#2D317F",
                fontWeight: state === "1" ? "800" : "600",
              }}
            >
              {products.shopiing_page.section_b.list[0]}
            </Box>
          </Box>
          <Box
            sx={{ display: "flex", gap: 2 }}
            onMouseEnter={() => setState("2")}
            onMouseLeave={() => setState("")}
          >
            <Number n="2" state={state} />
            <Box
              component="span"
              sx={{
                width: { xs: "300px", sm: "500px", md: "650px" },
                fontSize: { xs: "15px", sm: "20px" },
                color: "#2D317F",
                fontWeight: state === "2" ? "800" : "600",
              }}
            >
              {products.shopiing_page.section_b.list[1]}
            </Box>
          </Box>
          <Box
            sx={{ display: "flex", gap: 2 }}
            onMouseEnter={() => setState("3")}
            onMouseLeave={() => setState("")}
          >
            <Number n="3" state={state} />
            <Box
              component="span"
              sx={{
                width: { xs: "300px", sm: "500px", md: "650px" },
                fontSize: { xs: "15px", sm: "20px" },
                color: "#2D317F",
                fontWeight: state === "3" ? "800" : "600",
              }}
            >
              {products.shopiing_page.section_b.list[2]}
            </Box>
          </Box>
          <Box
            sx={{ display: "flex", gap: 2 }}
            onMouseEnter={() => setState("4")}
            onMouseLeave={() => setState("")}
          >
            <Number n="4" state={state} />
            <Box
              component="span"
              sx={{
                width: { xs: "300px", sm: "500px", md: "650px" },
                fontSize: { xs: "15px", sm: "20px" },
                color: "#2D317F",
                fontWeight: state === "4" ? "800" : "600",
              }}
            >
              {products.shopiing_page.section_b.list[3]}
            </Box>
          </Box>
          <Box
            sx={{ display: "flex", gap: 2 }}
            onMouseEnter={() => setState("5")}
            onMouseLeave={() => setState("")}
          >
            <Number n="5" state={state} />
            <Box
              component="span"
              sx={{
                width: { xs: "300px", sm: "500px", md: "650px" },
                fontSize: { xs: "15px", sm: "20px" },
                color: "#2D317F",
                fontWeight: state === "5" ? "800" : "600",
              }}
            >
              {products.shopiing_page.section_b.list[4]}
            </Box>
          </Box>
        </Box>
      </Box>
    </Container>
  );
}
